function replaceTemplating(text, templates, templateProps) {
  if (templates?.length === 0 || !templates) {
    return text;
  }
  const template = templates.shift();
  const templateKey = template.replace(/{|}| /g, '');
  let newText = text;
  if (templateKey && templateProps[templateKey]) {
    newText = text.replaceAll(template, templateProps[templateKey]);
  }
  return replaceTemplating(newText, templates, templateProps);
}
export default replaceTemplating;